module.exports = __webpack_public_path__ + "static/closer-to-the-moon-70c8776bc44b016a430c61745f63d7b1.jpg";